import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import Logo from 'assets/logo-avanta-mynd.svg';
import { useNavActions } from 'components/TopNav/hooks';
import { ROUTES } from 'constants/routes';

export const Footer = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.COMMON);
  const { primaryNavRoutes, primaryNavLinkLabel } = useNavActions();

  return (
    <footer className="h-52 w-full shrink-0 bg-denim-500">
      <div className="mx-auto flex h-full w-full max-w-7xl items-start gap-20 px-4.5 pt-4 am-lg:gap-22 am-lg:px-15 am-lg:pt-10">
        <Link to={ROUTES.HOME} className="shrink-0 self-start">
          <img src={Logo} alt="Avanta Mynd" className="block h-8 w-auto shrink-0 am-lg:h-9" />
        </Link>
        <nav
          aria-label={t('Footer.navLabel')}
          className="flex flex-col gap-3 text-sm font-medium leading-5 text-white"
        >
          {primaryNavRoutes.map(route => (
            <Link key={route.href} to={route.href} className="text-white hover:opacity-90">
              {primaryNavLinkLabel(route)}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
};
